import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

/**
 * External Link Warning Component
 * Shows a modal before navigating to external sites
 */
const ExternalLink = ({ href, children, className = '', ...props }) => {
    const [showWarning, setShowWarning] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        setShowWarning(true);
    };

    const handleProceed = () => {
        setShowWarning(false);
        window.open(href, '_blank', 'noopener,noreferrer');
    };

    const handleCancel = () => {
        setShowWarning(false);
    };

    return (
        <>
            <a
                href={href}
                onClick={handleClick}
                className={className}
                rel="noopener noreferrer"
                {...props}
            >
                {children}
            </a>

            {showWarning && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-300 p-4">
                    <div className="bg-card rounded-lg shadow-prominent max-w-md w-full animate-scale-in">
                        <div className="p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex items-center space-x-2">
                                    <Icon name="ExternalLink" size={20} className="text-primary" />
                                    <h3 className="text-lg font-semibold text-card-foreground">Leaving JobAspirant</h3>
                                </div>
                                <button
                                    onClick={handleCancel}
                                    className="p-1 hover:bg-muted rounded-md transition-colors duration-200"
                                >
                                    <Icon name="X" size={20} />
                                </button>
                            </div>

                            <div className="space-y-4">
                                <p className="text-sm text-muted-foreground">
                                    You are about to visit an external website:
                                </p>
                                <div className="bg-muted/50 rounded-lg p-3 break-all">
                                    <p className="text-sm font-mono text-foreground">{href}</p>
                                </div>
                                <p className="text-xs text-muted-foreground">
                                    This link will open in a new tab.
                                </p>

                                <div className="flex space-x-3 pt-2">
                                    <Button
                                        variant="outline"
                                        onClick={handleCancel}
                                        className="flex-1"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="default"
                                        onClick={handleProceed}
                                        className="flex-1"
                                        iconName="ExternalLink"
                                        iconPosition="left"
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ExternalLink;
